import {
  IScreenDesignContextState,
  ScreenDesignContext
} from "../../contexts/screen-design-context/screen-design-context";

export interface IWithSDProps {
  sd: IScreenDesignContextState;
}

export const withSD = <P extends object>(Component: any) => {
  return (props: P) => {
    return (
      <ScreenDesignContext.Consumer>
        {(ScreenDesignContext: IScreenDesignContextState) => <Component {...props} sd={ScreenDesignContext} />}
      </ScreenDesignContext.Consumer>
    );
  };
};
